<div class="container">

  <div class="title title--lg" style="text-align: center;">Welcome to the Legal Review Portal</div>

  <div>Please mark the following application(s):
    <ul>
      <li><strong>Pass</strong>: if the legal team determines the application can move foward in the membership process.
      </li>
      <li><strong>Reject</strong>: if the application fails to meet the legal standards required for membership.</li>
    </ul>
  </div>

  <div *ngIf="dataSource && dataSource.length > 0">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 full-width-table">

      <ng-container matColumnDef="mastercustomerId">
        <th mat-header-cell *matHeaderCellDef> MastercustomerId </th>
        <td mat-cell *matCellDef="let element" (click)="viewApplicant(element.applicantId)">
          <span class="clickable">{{element.mastercustomerId}}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="firstName">
        <th mat-header-cell *matHeaderCellDef> First Name </th>
        <td mat-cell *matCellDef="let element"> {{element.firstName}} </td>
      </ng-container>

      <ng-container matColumnDef="middleName">
        <th mat-header-cell *matHeaderCellDef> Middle Name </th>
        <td mat-cell *matCellDef="let element"> {{element.middleName}} </td>
      </ng-container>

      <ng-container matColumnDef="lastName">
        <th mat-header-cell *matHeaderCellDef> Last Name </th>
        <td mat-cell *matCellDef="let element"> {{element.lastName}} </td>
      </ng-container>

      <ng-container matColumnDef="birthDate">
        <th mat-header-cell *matHeaderCellDef> Birthday </th>
        <td mat-cell *matCellDef="let element"> {{element.birthDate | date:'y MMMM d' }} </td>
      </ng-container>

      <ng-container matColumnDef="submittedDate">
        <th mat-header-cell *matHeaderCellDef> Submitted Date </th>
        <td mat-cell *matCellDef="let element"> {{element.submittedDate | date:'y MMMM d' }} </td>
      </ng-container>

      <ng-container matColumnDef="memberApplicationTypeName">
        <th mat-header-cell *matHeaderCellDef> Application Type </th>
        <td mat-cell *matCellDef="let element"> {{element.memberApplicationTypeName}} </td>
      </ng-container>

      <ng-container matColumnDef="pass">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let item">
          <button class="btn btn--small  btn--outline w100 font-size-11" (click)="pass(item)">
            pass
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="reject">
        <th mat-header-cell *matHeaderCellDef></th>

        <td mat-cell *matCellDef="let item">
          <button class="btn  btn--small btn--solid w100 font-size-11" (click)="reject(item)">
            reject
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>

  <div *ngIf="!dataSource || dataSource.length == 0">No records found.</div>


  <app-aaos-spinner [isLoading]="loading"></app-aaos-spinner>
</div>